export default __webpack_public_path__ + "static/media/product-bg.858ccf6a.jpg";